// PROD-1806 — silently report the device IANA timezone on every launch and login.
// Fire-and-forget: errors are ignored (the next launch retries).

import type { ApiInstance } from 'src/hooks/use-axios';

// One send per (user, timezone) per page load; a new launch resets it, a login as
// a different user (or an actual timezone change) re-sends.
let lastReported: string | null = null;

export function reportDeviceTimezone(api: ApiInstance, userId: number | undefined): void {
  if (!userId) return;

  let timezone: string | undefined;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
  if (!timezone) return;

  const key = `${userId}:${timezone}`;
  if (key === lastReported) return;
  lastReported = key;

  api.patch(`v1/users/${userId}/`, { timezone }).catch(() => {
    lastReported = null; // let a later call retry
  });
}

/** Test hook: forget the last report so a fresh launch can be simulated. */
export function resetReportedTimezoneForTests(): void {
  lastReported = null;
}
